import { Component, ChangeDetectionStrategy } from '@angular/core';
import isEmpty from 'lodash-es/isEmpty';

import { ReservationAssistance, ReservationFlight } from '@user-history/entities/history-booking-detail';
import { IMAGE_TYPE } from '@ux/components/image/constants/image-type.constants';
import { TravelDetailProvider } from '@shared/flight-itinerary/entities/travel-detail-provider';
import { ReservationType } from '@user-history/entities/user-history-item';
import { getArrivalAirportCode } from '@user-history/mappers/reservation-flight.mapper';
import { ImageCdnPipe } from '@app/pipes/image-cdn.pipe';
import { ReservationStatus } from '@user-history/entities/reservation-status';
import { formatReservation } from '@user-history/pipes/air-reservation-format.pipe';
import { AbandonedReservationsAbstract } from '@abandoned-reservation/abstracts/abandoned-reservations.abstract';
import { AirValidationSector } from '@app/entities/air-validation.response';

@Component({
  selector: 'app-abandoned-flight-reservation',
  templateUrl: './abandoned-flight-reservation.component.html',
  styleUrls: ['./abandoned-flight-reservation.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})

export class AbandonedFlightReservationComponent extends AbandonedReservationsAbstract {

  public readonly BASE_PATH: string = 'web/travel/assistance';
  public readonly IMAGE: string = 'CHUBB.png';

  public typeImage: string = IMAGE_TYPE.FLIGHT;
  public summaryProvider: TravelDetailProvider = TravelDetailProvider.BOOKING_FLIGHT;
  public hasImage = true;

  constructor(
    private imageCdnPipe: ImageCdnPipe,
  ) {
    super()
  }

  get reservationImageByDestination(): string {
    if (this.arrivalAirportCode) {
      const name = `dest-${this.arrivalAirportCode.toLowerCase()}.jpg`;
      const folder = 'web/travel/destinations';
      return this.imageCdnPipe.baseImage(name, folder);
    } else return null;
  }

  get airReservationItem(): ReservationFlight {
    return !isEmpty(this.firstReservation) ? formatReservation(this.firstReservation) : {} as ReservationFlight;
  }

  get assistanceItem(): ReservationAssistance {
    return this.itinerary?.AssistanceReservation;
  }

  get arrivalAirportCode(): string {
    return getArrivalAirportCode(this.airReservationItem);
  }

  get reservations(): ReservationFlight[] {
    const _reservations = this.itinerary?.Reservations as ReservationFlight[];
    return !!_reservations && _reservations
      .filter(reservation =>
        reservation?.ReservationType === ReservationType.Flight &&
        reservation?.Status === ReservationStatus.OnHold
      );
  }

  get sectors(): AirValidationSector[] {
    const sectorsMatrix = this.reservations?.map(reservation => reservation.Sectors);
    const sectorCollection = [].concat(...sectorsMatrix);
    return sectorCollection;
  }

  private get firstReservation(): ReservationFlight {
    return this.reservations?.[0] as ReservationFlight;
  }

  public backgroundAssistanceImageByItem(url: string): { [key: string]: string } {
    const uri = encodeURI(url);
    return {
      'background-image': `url(${uri})`,
      'background-repeat': 'no-repeat',
      'background-size': 'contain',
      'background-position': '50%',
    };
  }

  public errorImage(event: boolean) {
    this.hasImage = !event;
  }
}
